import { Connection, ConnectionsResponse, ConnectionStatus } from './types'

import { client } from 'src/utils/client'
import config from 'src/config'

export const getConnections = async (
  connectionStatus?: ConnectionStatus,
  page?: { skip: number }
): Promise<ConnectionsResponse> => {
  const params = new URLSearchParams({})

  if (connectionStatus) {
    params.append('status', connectionStatus)
  }
  if (page) {
    params.append('$skip', String(page.skip))
  }

  const queryString = params.toString()

  return await client(
    `${config.HOST_API}/connections${
      queryString.length > 0 ? `?${queryString}` : ''
    }`
  )
}

export const getConnection = async (
  connectionId: string
): Promise<Connection> =>
  await client(`${config.HOST_API}/connections/${connectionId}`)

export const inviteConnection = async (userInput: string) =>
  await client(`${config.HOST_API}/connections/invite`, { body: { userInput } })

export const approveConnection = async (
  otherUserId: string
): Promise<Connection> =>
  await client(`${config.HOST_API}/connections/approve`, {
    body: { otherUserId },
  })

export const denyConnection = async (
  otherUserId: string
): Promise<Connection> =>
  await client(`${config.HOST_API}/connections/deny`, {
    body: { otherUserId },
  })

export const removeFriend = async (otherUserId: string) =>
  await client(`${config.HOST_API}/connections/remove`, {
    body: { otherUserId },
  })
